import React, { useContext } from 'react';
import style from './style.module.scss';
import List from '../list';
import Input from '../input';
import { CommentsContext } from '../../../context/CommentsContext';
import Button from '../../button';

function Box() {
  const { currentPage, setCurrentPage, lastPage } = useContext(CommentsContext);

  return (
    <div className={style.box}>
      <h3 className={style.title}>Comentários</h3>
      <Input />
      <List />
      {!lastPage && (
        <div className={style.buttonContnainer}>
          <Button
            size="full"
            onClick={e => setCurrentPage(currentPage + 1)}
          >
            Carregar Mais
          </Button>
        </div>
      )}
    </div>
  );
}

export default Box;
